import {
  CompetenceBaseTreeEx,
  LearningOpportunityName,
} from "@/server/backend-api";
import { ContactFormSetting } from "@/server/backend-api/generated";
import { OrganisationBase } from "@/server/backend-api/organisation";
import { DUMMY_TREE } from "@/utils/competenceTree";
import React, { FC, PropsWithChildren, useContext, useMemo } from "react";
import {
  CompetenceTreeUtils,
  createCompetenceTreeUtils,
  defaultCompetenceTreeUtils,
} from "../../utils/competenceTreeUtils";

export type BaseContext = {
  competenceTree: CompetenceBaseTreeEx;
  competenceTreeUtils: CompetenceTreeUtils;
  memberUniversities: OrganisationBase[];
  contactFormSettings: ContactFormSetting[];
  learningOppNames: LearningOpportunityName[];
};

const BaseContext = React.createContext<BaseContext>({
  competenceTree: DUMMY_TREE,
  competenceTreeUtils: defaultCompetenceTreeUtils,
  memberUniversities: [],
  contactFormSettings: [],
  learningOppNames: [],
});
interface Props {
  competenceTree: CompetenceBaseTreeEx;
  memberUniversities: OrganisationBase[];
  contactFormSettings: ContactFormSetting[];
  learningOpps: LearningOpportunityName[];
}

export const BaseContextProvider: FC<PropsWithChildren<Props>> = (props) => {
  const competenceTreeUtils = useMemo(
    () => createCompetenceTreeUtils(props.competenceTree),
    [props.competenceTree]
  );

  return (
    <BaseContext.Provider
      value={{
        competenceTree: props.competenceTree,
        competenceTreeUtils,
        memberUniversities: props.memberUniversities,
        contactFormSettings: props.contactFormSettings,
        learningOppNames: props.learningOpps,
      }}
    >
      {props.children}
    </BaseContext.Provider>
  );
};

export const useBaseContext = () => {
  return useContext(BaseContext);
};
